import {createReducer} from '@reduxjs/toolkit';

import {SORT_DIRECTIONS} from '../constants/index.js';
import {
  setActiveResultId,
  setResultsSortDirection,
  setScenesSortDirection,
  showFiltersPanel,
} from '../actions/sidebar.js';

const initialState = {
  activeResultId: null,
  showFiltersPanel: false,
  resultsSortDirection: SORT_DIRECTIONS.DSC,
  scenesSortDirection: SORT_DIRECTIONS.DSC,
};

const sidebar = createReducer(initialState, builder => {
  builder.addCase(setActiveResultId, (state, {payload}) => {
    state.activeResultId = payload;
  });

  builder.addCase(showFiltersPanel, (state, {payload}) => {
    // normalize the boolean.
    state.showFiltersPanel = payload === true;
  });

  builder.addCase(setResultsSortDirection, (state, {payload}) => {
    state.resultsSortDirection = payload;
  });

  builder.addCase(setScenesSortDirection, (state, {payload}) => {
    state.scenesSortDirection = payload;
  });
});

export default sidebar;
